import TextBody from 'components/TextBody'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'

export default function TextBodyLight (props) {
  return (
    <TextBody
      fw='light'
      c={STYLES_COLOR.BLACK_LIGHT}
      {...props}
    />
  )
}
